import React, { FC } from 'react';
import Colors from '@domain/constant/colors';

import styles from './timer.module.scss';
import classNames from 'classnames/bind';

import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';

const cx = classNames.bind(styles);

interface Props {
  className?: string;
  title: string;
  leftTime: number;
  totalTime: number;
}

const DASH = 2 * Math.PI * 100;
const RADIUS = 100;
const CENTER = 104;

export const Timer: FC<Props> = (props) => {
  const { title, leftTime, totalTime } = props;

  const formatTime = () => {
    const minutes = Math.floor(leftTime / 60);
    const remainingSeconds = leftTime % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const remainingRatio = leftTime / totalTime;
  const endAngle = 2 * Math.PI * remainingRatio - Math.PI / 2; // -Math.PI/2 to start from the top
  const startAngle = -Math.PI / 2; // Starting at the top

  const endX = CENTER - RADIUS * Math.cos(endAngle);
  const endY = CENTER + RADIUS * Math.sin(endAngle);
  const startX = CENTER + RADIUS * Math.cos(startAngle);
  const startY = CENTER + RADIUS * Math.sin(startAngle);

  return (
    <div className={cx('chart', props.className)}>
      <svg className={cx('donut')} width={320} height={320} viewBox={'0 0 208 208'}>
        <circle
          className={cx('donut-ring')}
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill={'transparent'}
          strokeWidth={'8'}
        />
        <circle
          className={cx('donut-segment')}
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill={'transparent'}
          strokeWidth={'8'}
          strokeDasharray={`${DASH * (1 - remainingRatio)} ${DASH}`}
        />
        <circle className={cx('donut-border')} cx={startX} cy={startY} r={4} fill={Colors.C_GREEN_150} />
        <circle className={cx('donut-border')} cx={endX} cy={endY} r={4} fill={Colors.C_GREEN_150} />
      </svg>

      <div className={cx('center')}>
        <Text fontStyle={FontStyle.H1_B} color={Colors.C_GREEN_150}>
          {formatTime()}
        </Text>
        <Text fontStyle={FontStyle.H5_B} color={Colors.C_COOL_GRAY_60} styles={{ marginTop: 8 }}>
          {title}
        </Text>
      </div>
    </div>
  );
};
